import * as yup from 'yup'
import { FORM_FIELDS } from './enum'

export const useSchema = () => {
  return yup.object().shape({
    [FORM_FIELDS.testType]: yup.number().required(),
  })
}
